import { memo } from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { Description } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useCentralizedExport } from 'contexts/CentralizedExportProvider';
import { InventoryDownloadService, SalesDownloadService } from 'modules/export/services';

const OrderExportInvoice = ({ orderId }: { orderId: string }) => {
  const { t } = useTranslation('order');
  const { triggerExport } = useCentralizedExport();

  const handleExportInvoice = () => {
    triggerExport({
      title: 'common:exportDialog.title',
      confirmation: 'common:exportDialog.confirmation',
      total: 1,
      exportHook: async () => {
        const payload = {
          total: 1,
          search: '',
        };
        return await SalesDownloadService._getExportPath(payload, `/orders/export/${orderId}/invoice`);
      },
      downloadFn: InventoryDownloadService._downloadFileToPDF,
      storageKey: '_export_hide_single_order_invoice',
    });
  };

  return (
    <MenuItem onClick={handleExportInvoice}>
      <ListItemIcon>
        <Description fontSize='small' />
      </ListItemIcon>
      <ListItemText>{t('header.actions.export.exportInvoice')}</ListItemText>
    </MenuItem>
  );
};

export default memo(OrderExportInvoice);
